(function () {
  var supportsHoverFine =
    window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Skip entirely on touch-only devices or when the visitor prefers reduced motion.
  if (!supportsHoverFine || reducedMotion) return;

  var MAX_TILT_DEG = 7;
  var MAX_SCALE = 1.045;

  function closestProductMedia(node) {
    return node && node.closest ? node.closest('.product-media') : null;
  }

  function handleMove(event) {
    if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;

    var target = closestProductMedia(event.target);
    if (!target) return;

    var img = target.querySelector('.product-media__image');
    if (!img) return;

    var rect = target.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var x = (event.clientX - rect.left) / rect.width;
    var y = (event.clientY - rect.top) / rect.height;

    var rotateY = (x - 0.5) * MAX_TILT_DEG * 2;
    var rotateX = (0.5 - y) * MAX_TILT_DEG * 2;

    img.style.transform =
      'scale(' + MAX_SCALE + ') rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg)';
    target.classList.add('product-media--tilting');
  }

  function handleOut(event) {
    var target = closestProductMedia(event.target);
    if (!target) return;

    // Ignore transitions between children still inside the same product-media element.
    if (event.relatedTarget && target.contains(event.relatedTarget)) return;

    var img = target.querySelector('.product-media__image');
    if (img) img.style.transform = '';
    target.classList.remove('product-media--tilting');
  }

  document.addEventListener('pointermove', handleMove, { passive: true });
  document.addEventListener('pointerout', handleOut, { passive: true });
})();
